import React from 'react'

export default function Drawer({ drawer, action }) {
    // const [itemSize, setSize] = useState('0px');
    // const [item, setItem] = useState('home');
    
    const handler = (e, value) => {
        e.preventDefault();
        // const getItems = document.querySelectorAll(`#${value} li`).length;
        // if (getItems > 0) {
        //     setSize(`${43 * getItems}px`);
        //     setItem(value);
        // }
    }

    return (
        <>
            <div className="offcanvas_menu">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className={`offcanvas_menu_wrapper ${drawer ? 'active' : ''}`}>
                                <div id="menu" className="text-center">
                                    <ul className="offcanvas_main_menu">
                                        <li
                                            onClick={(e) => handler(e, 'personalLoan')}
                                            id="personalLoan"
                                        >
                                            <a href="https://cashconverters.co.nz/borrow/">Personal Loans</a>
                                        </li>
                                        <li
                                            onClick={(e) => handler(e, 'Pawn')}
                                            id="Pawn"
                                        >
                                            <a href="https://cashconverters.co.nz/pawns/ ">Pawn With Us</a>
                                        </li>
                                        <li
                                            onClick={(e) => handler(e, 'Sell')}
                                            id="Sell"
                                        >
                                            <a href="https://cashconverters.co.nz/sell/ ">Sell To Us</a>
                                        </li>
                                        <li
                                            onClick={(e) => handler(e, 'Buy')}
                                            id="Buy"
                                        >
                                            <a href="https://cashconverters.co.nz/buy/">Buy From Us</a>
                                        </li>
                                        <li
                                            onClick={(e) => handler(e, 'Stores')}
                                            id="Stores"
                                        >
                                            <a href="https://cashconverters.co.nz/stores/">Our Stores</a>
                                        </li>
                                        <li
                                            onClick={(e) => handler(e, 'about')}
                                            id="about"
                                        >
                                            <a href="https://cashconverters.co.nz/about-us/">About Us</a>
                                        </li>
                                        <li
                                            onClick={(e) => handler(e, 'join')}
                                            id="join"
                                            className="active"
                                        >
                                            <a href="/">Join Us</a>
                                        </li>
                                        <li
                                            onClick={(e) => handler(e, 'contact')}
                                            id="contact"
                                        >
                                            <a href="https://cashconverters.co.nz/contact-us/">Contact Us</a>
                                        </li>
                                    </ul>
                                </div>
                              
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div 
                onClick={(e) => action(e)}
                className={`off_canvars_overlay ${drawer ? 'active' : ''}`}
            ></div>
        </>
    )
}